import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { getBreadcrumbSchema } from '../components/StructuredData';

const CookiesPolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <SEO
        title={t('seo.cookiesPolicy.title')}
        description={t('seo.cookiesPolicy.description')}
        canonicalPath="/cookies-policy"
        jsonLd={[
          getBreadcrumbSchema([
            { name: 'Home', url: '/' },
            { name: t('cookiesPolicy.title'), url: '/cookies-policy' },
          ]),
        ]}
      />

      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('cookiesPolicy.title')}
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('cookiesPolicy.introTitle')}
          </Typography>
          <Typography paragraph>
            {t('cookiesPolicy.introText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('cookiesPolicy.whatAreCookiesTitle')}
          </Typography>
          <Typography paragraph>
            {t('cookiesPolicy.whatAreCookiesText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('cookiesPolicy.typesOfCookiesTitle')}
          </Typography>
          <Typography paragraph>
            {t('cookiesPolicy.typesOfCookiesText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('cookiesPolicy.cookiesWeUseTitle')}
          </Typography>
          <Typography paragraph>
            {t('cookiesPolicy.cookiesWeUseText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('cookiesPolicy.howToManageTitle')}
          </Typography>
          <Typography paragraph>
            {t('cookiesPolicy.howToManageText')}
          </Typography>
          
          <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
            {t('cookiesPolicy.changesPolicyTitle')}
          </Typography>
          <Typography paragraph>
            {t('cookiesPolicy.changesPolicyText')}
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            {t('cookiesPolicy.lastUpdated')}: 2023-11-01
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default CookiesPolicy;
